module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-statistics-card statistics-card-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns small-6 medium-2"
  }, [_c('div', {
    staticClass: "inner-content card"
  }, [_vm._t("n1")], 2)]), _c('div', {
    staticClass: "columns small-6 medium-2"
  }, [_c('div', {
    staticClass: "inner-content card"
  }, [_vm._t("n2")], 2)]), _c('div', {
    staticClass: "columns small-6 medium-2"
  }, [_c('div', {
    staticClass: "inner-content card"
  }, [_vm._t("n3")], 2)]), _c('div', {
    staticClass: "columns small-6 medium-2"
  }, [_c('div', {
    staticClass: "inner-content card"
  }, [_vm._t("n4")], 2)]), _c('div', {
    staticClass: "columns small-6 medium-2"
  }, [_c('div', {
    staticClass: "inner-content card"
  }, [_vm._t("n5")], 2)]), _c('div', {
    staticClass: "columns small-6 medium-2"
  }, [_c('div', {
    staticClass: "inner-content card"
  }, [_vm._t("n6")], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4d4051ae!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/StatisticsCard6.vue
// module id = 2480
// module chunks = 1